// extracted by mini-css-extract-plugin
export default {"main":"Bullet_main__ScTdp","main_current":"Bullet_main_current__fTx6z","inner":"Bullet_inner__El4A+"};